import { createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';

import middleware from '../middleware';
import rootReducer from '../reducers/rootReducer';
import loadState from './loadState';

const composeEnhancers = composeWithDevTools({});
const enhancers = composeEnhancers(middleware);

export default function configureStore(initialState = loadState()) {
  const store = createStore(rootReducer, initialState, enhancers);
  return store;
}
